import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import DynaSpan from './DynaSpan';
import type { EIP6963ProviderDetail } from '../utils/WalletProviders';

interface WalletSelectModalProps {
  show: boolean;
  wallets: EIP6963ProviderDetail[];
  /** rdns of the wallet used last time, flagged as a hint. */
  lastUsedRdns?: string | null;
  onSelect: (wallet: EIP6963ProviderDetail) => void;
  onCancel: () => void;
}

/**
 * Shown when more than one wallet extension is installed. Picking one here is
 * what keeps us off the shared `window.ethereum` aggregator that breaks in
 * Chrome when several wallets fight over it.
 */
const WalletSelectModal = ({ show, wallets, lastUsedRdns, onSelect, onCancel }: WalletSelectModalProps) => (
  <Modal show={show} onHide={onCancel} centered dialogClassName="walletModal">
    <Modal.Header closeButton closeVariant="white">
      <Modal.Title as="h2" className="dyna">Choose a wallet</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="walletModalIntro">
        You have more than one wallet installed. Which would you like to use with <DynaSpan />?
      </p>
      <div className="walletOptions">
        {wallets.map((wallet) => (
          <Button
            key={wallet.info.uuid}
            variant="primary"
            className="walletOption"
            onClick={() => onSelect(wallet)}
          >
            {wallet.info.icon && (
              <img className="walletOptionIcon" src={wallet.info.icon} alt="" />
            )}
            <span className="walletOptionName">{wallet.info.name}</span>
            {wallet.info.rdns === lastUsedRdns && (
              <span className="walletLastUsed">last used</span>
            )}
          </Button>
        ))}
      </div>
    </Modal.Body>
  </Modal>
);

export default WalletSelectModal;
